import { SoundFilled } from '@ant-design/icons';
import { useState } from 'react';
import styled from 'styled-components';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var StyledVolumeInput = styled.div.withConfig({
  displayName: "audio-volume-inputcomponent__StyledVolumeInput",
  componentId: "sc-1s5dqe8-0"
})(["display:flex;align-items:center;align-self:stretch;padding:0 4px;"]);
var StyledSoundOutlined = styled(SoundFilled).withConfig({
  displayName: "audio-volume-inputcomponent__StyledSoundOutlined",
  componentId: "sc-1s5dqe8-1"
})(["font-size:18px;cursor:pointer;"]);
var StyledInput = styled.input.withConfig({
  displayName: "audio-volume-inputcomponent__StyledInput",
  componentId: "sc-1s5dqe8-2"
})(["width:70px;margin:0;margin-left:10px;height:3px;border-radius:9999px;accent-color:#000;background-color:#000;cursor:pointer;"]);
export default function VolumeInput(props) {
  var volume = props.volume,
      onVolumeChange = props.onVolumeChange,
      onToggleMute = props.onToggleMute;

  var _useState = useState(false),
      isHovered = _useState[0],
      setIsHovered = _useState[1];

  return /*#__PURE__*/_jsxs(StyledVolumeInput, {
    onMouseLeave: function onMouseLeave() {
      return setIsHovered(false);
    },
    children: [/*#__PURE__*/_jsx(StyledSoundOutlined, {
      onClick: onToggleMute,
      onMouseEnter: function onMouseEnter() {
        return setIsHovered(true);
      }
    }), isHovered && /*#__PURE__*/_jsx(StyledInput, {
      "aria-label": "volume",
      name: "volume",
      type: "range",
      min: 0,
      step: 0.05,
      max: 1,
      value: volume,
      onChange: function onChange(e) {
        onVolumeChange(e.currentTarget.valueAsNumber);
      }
    })]
  });
}